import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, of, Subject, tap, timeout } from 'rxjs';
import { agentCodeAddPrefix0 } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';
import { EmployerHistoryRequest } from '../employer-history/employer-history-request';
import { ErChanegSummaryDetailResponse } from './er-change-summary-detail-response';

@Injectable({
  providedIn: 'root',
})
export class ErChangeSummaryDetailService {
  private httpClient = inject(HttpClient);

  searchEmployeeUrl = `${environment.apiPrefix}${environment.customerServiceExt}/update-delegation/members/query`;
  employeeDataSubject = new Subject<ErChanegSummaryDetailResponse>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorEmployeeSubject = new Subject<any>();

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  getDetailList(request: EmployerHistoryRequest) {
    this.httpClient
      .post(this.searchEmployeeUrl, request, this.httpOptions)
      .pipe(
        tap(() => console.info('fetched employees')),
        timeout(5000),
        catchError(this.handleError<ErChanegSummaryDetailResponse>('getDetailList', new ErChanegSummaryDetailResponse()))
      )
      .subscribe((resp: ErChanegSummaryDetailResponse) => {
        resp.data?.content?.forEach(c => {
          c.items.forEach(item => {
            if (item.oldAgent?.agentCode) {
              item.oldAgent.agentCode = agentCodeAddPrefix0(item.oldAgent.agentCode);
            }
            if (item.submitAgent?.agentCode) {
              item.submitAgent.agentCode = agentCodeAddPrefix0(item.submitAgent.agentCode);
            }
            if (item.targetAgent?.agentCode) {
              item.targetAgent.agentCode = agentCodeAddPrefix0(item.targetAgent.agentCode);
            }
          });
        });

        this.employeeDataSubject.next(resp);
      });
  }

  handleError<T>(operation = 'operation', result?: T) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error: any): Observable<T> => {
      console.error(error);
      console.info(`${operation} failed :${error.message}`);
      this.errorEmployeeSubject.next(`${error.message}`);
      return of(result as T);
    };
  }
}
